import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MapPin, Search, ArrowRight } from "lucide-react";
import { SERVICE_AREAS, COMPANY } from "@/data/content";
import { CITY_LIST } from "@/data/cities";

export default function ServiceArea({ onQuote }) {
  return (
    <section id="area" className="py-24 bg-carbon border-y border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-honey font-bold mb-3">Are You in Our Service Area?</p>
          <h2 className="text-4xl sm:text-5xl font-display font-black uppercase tracking-tighter text-white">
            Roofing Snohomish, King &amp; Skagit Counties
          </h2>
          <p className="text-zinc-400 mt-4 text-lg leading-relaxed">
            Based in <span className="text-white font-semibold">Everett, WA</span>, Honey Bee Roofing &amp; Exteriors is a
            locally owned, licensed Washington contractor. We serve homeowners across
            <span className="text-white"> Snohomish County, King County, and Skagit County</span> — from Arlington, Marysville
            and Everett to Seattle, Bellevue and Mount Vernon. Searching for a
            <span className="text-white"> roofing contractor near me in the 425 area</span>? You're in the right hive.
          </p>
          <button onClick={onQuote} data-testid="area-quote-btn"
            className="mt-7 inline-flex items-center gap-2 bg-honey text-obsidian font-bold px-6 py-3.5 rounded-sm hover:bg-honey-600 transition-colors">
            <Search className="w-4 h-4" /> Check My Address
          </button>

          <div className="mt-7">
            <p className="text-xs uppercase tracking-wider text-zinc-500 font-semibold mb-2.5">Popular roofing areas</p>
            <div className="flex flex-wrap gap-2.5">
              {CITY_LIST.map((c) => (
                <Link key={c.slug} to={`/roofing/${c.slug}`} data-testid={`area-city-${c.slug}`}
                  className="group inline-flex items-center gap-1.5 px-4 py-2 rounded-sm border border-honey/30 bg-honey/5 text-sm font-semibold text-honey hover:bg-honey hover:text-white transition-colors">
                  Roofing in {c.name} <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-2.5">
          {SERVICE_AREAS.map((a, i) => (
            <motion.span key={a}
              initial={{ opacity: 0, scale: 0.9 }} whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }} transition={{ delay: i * 0.03 }}
              className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-sm border border-white/10 bg-obsidian text-sm text-zinc-200 hover:border-honey/40 hover:text-honey transition-colors">
              <MapPin className="w-3.5 h-3.5 text-honey" /> {a}
            </motion.span>
          ))}
        </div>
      </div>
      <p className="sr-only">{COMPANY.areasShort}</p>
    </section>
  );
}
